{
    "e2osrIT36gHAMjfxeW7dH": {
        "key": "e2osrIT36gHAMjfxeW7dH",
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "o2dttJr69k8HZjGbxZirS": {
        "key": "o2dttJr69k8HZjGbxZirS",
        "position": {
            "x": 0,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "XxXVVLn7AohpzPaq8Nhgw": {
        "position": {
            "x": 3,
            "y": 2,
            "z": 1
        },
        "templateKey": "jobs/hero/archer",
        "jobKey": "hero/archer",
        "affiliation": "bad",
        "key": "XxXVVLn7AohpzPaq8Nhgw"
    }
}